import { hocify } from '../hocify/hocify';
import constate from 'constate';
// Exposing the Context on the Provider.
var injectContext = function (Provider, ctx) {
    var ProviderWithContext = Provider;
    ProviderWithContext.Context = ctx;
    return ProviderWithContext;
};
export var contextify = function (useValue) {
    var result = constate(useValue);
    var Provider = result[0], useHookContext = result[1];
    return {
        Provider: injectContext(Provider, result.Context),
        withHookContext: hocify(useHookContext),
        useHookContext: useHookContext,
    };
};
//# sourceMappingURL=contextify.js.map